"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "graffignana": {
    "532d8254": [{
      "hkey": "132d7070",
      "slug": "vimagano-molina",
      "name": "Vimagano-Molina",
      "primary": true,
      "skipSearch": false
    }],
    "molina": [{
      "hkey": "132d7070",
      "slug": "vimagano-molina",
      "name": "Vimagano-Molina",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "graffignana"
    }],
    "54665f9a": [{
      "hkey": "132d7070",
      "slug": "vimagano-molina",
      "name": "Vimagano-Molina",
      "primary": true,
      "skipSearch": false
    }],
    "vimagano": [{
      "hkey": "132d7070",
      "slug": "vimagano-molina",
      "name": "Vimagano-Molina",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "graffignana"
    }]
  }
};
exports["default"] = _default;